<template>
  <router-link
    v-if="threadLink"
    :to="{ path: `/forums/${threadLink}` }"
    class="forum-starter-success link--unstyled"
  >
    <h2 class="forum-starter-success__heading">
      Thank you for sharing!  Your question has been posted in Forums.
    </h2>
    <p class="forum-starter-success__cta-text">
      View my forum
      <icon-component
        name="caret"
        title="caret icon"
        class="forum-starter-success__cta-icon"
      />
    </p>
  </router-link>
</template>

<script>
export default {
  name: 'ForumStarterSuccess',
  props: {
    threadLink: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_forum-starter-success';
</style>
